<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="dedication">
<h2 class="center2">To my parents,</h2>
<h2 class="center0">Levan and Marina Mikaberidze,</h2>
<h2 class="center0">who gave up so much for their children</h2>
<h2 class="center0">and instilled in them a passion for learning.</h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// therussian_dedication.vue?70633134